export default "__VITE_ASSET__puMyjL71__"